import { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { useIntl } from 'react-intl'
import { View } from 'react-native'
import styled from 'styled-components'
import { useFeatureFlag, useSearchQuery } from '@mwxltd/flix-api-client'
import { ContentList } from '@flix/common/domain/content-lists'
import { SearchInput } from '@flix/common/domain/search/SearchInput/SearchInput'
import messages from '@flix/common/domain/search/messages'
import { useButtonHandlers } from '@flix/common/elements/controls'
import { MaxWidthView } from '@flix/common/elements/layout'
import { useMediaBreakpoints } from '@flix/common/style/media'
import { FilmListEmpty } from '../../../components/film/FilmListEmpty/FilmListEmpty'
import { AppState } from '../../../containers/app/AppState/AppState'
import LoadError from '../../../containers/errors/LoadError/LoadError'
import errorMsgs from '../../../containers/errors/messages'
import { canonicalUrl } from '../../../utils/htmlHead'
import meta from '../../metaDescriptions'
import { SearchLeaderboardAd } from './SearchLeaderboardAd'

const Container = styled(View)`
  justify-content: center;
  flex-direction: row;
`

const SearchPage = ({ location }) => {
  const { getFlagValue } = useFeatureFlag()
  const bannerAdsEnabled = getFlagValue('bannerAdsEnabled')

  const intl = useIntl()
  const { sm } = useMediaBreakpoints()
  const { searchPhrase, updateSearchPhrase } = useContext(AppState)

  const { error, loading, onFetchMore, data } = useSearchQuery({
    query: searchPhrase,
    limit: 30,
  })

  const {
    handlers: { viewDetails },
  } = useButtonHandlers()

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(meta.searchTitle)}</title>
        <meta property="og:title" content="Search Flix Premiere" />
        <meta
          name="description"
          property="og:description"
          content={intl.formatMessage(meta.search)}
        />
        <meta property="og:url" content={canonicalUrl(location)} />
        <link rel="canonical" href={canonicalUrl(location)} />
      </Helmet>

      <Container>
        {/*{lg && <SearchSkyscraperAd zone="searchPage" placement="leftWideSkyscraper" />}*/}
        <MaxWidthView overrideMediaWidth centered={false} style={{ flex: 1 }}>
          <SearchInput
            value={searchPhrase}
            onChangeText={(value) => {
              updateSearchPhrase(value)
              window.scrollTo(0, 0)
            }}
          />

          {error ? (
            <LoadError {...errorMsgs.loadingSearch} />
          ) : (
            <ContentList
              list={data?.searchResults}
              onItemChosen={viewDetails}
              refreshing={loading}
              bounces={false}
              overScrollMode="never"
              onEndReachedThreshold={0.8}
              onEndReached={onFetchMore}
              maxColumns={5}
              ListEmptyComponent={FilmListEmpty}
              emptyLabel={searchPhrase?.length > 1 ? messages.noResults : messages.searchBy}
            />
          )}
          {!sm && bannerAdsEnabled && (
            <SearchLeaderboardAd
              zone="searchPage"
              placementXs="bottomLeaderboardMobile"
              placementSm="bottomLeaderboard"
            />
          )}
        </MaxWidthView>
        {/*{lg && <SearchSkyscraperAd zone="searchPage" placement="rightWideSkyscraper" />}*/}
      </Container>
    </>
  )
}

export default SearchPage
